import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';
import { TeacherService } from 'app/teacher/services/teacher.service';

@Component({
  selector: 'kh-renew-class-modal',
  templateUrl: './renew-class-modal.component.html',
  styleUrls: ['./renew-class-modal.component.less'],
  standalone: false
})
export class RenewClassModalComponent {
  private readonly bsModalRef = inject(BsModalRef);
  private readonly router = inject(Router);
  private readonly teacherService = inject(TeacherService);

  public classId(): string {
    return this.teacherService.activeClassId;
  }

  public async goToContact(): Promise<void> {
    const route = TEACHER_ROUTE.HELP_CENTER.route(this.classId());
    await this.router.navigate(route);
    this.cancel();
  }

  public cancel(): void {
    this.bsModalRef.hide();
  }
}
